import React, { useState } from 'react';
import { MessageCircle, X } from 'lucide-react';

/**
 * WhatsAppButton - Floating WhatsApp support button
 * Provides instant access to WhatsApp support
 */
export const WhatsAppButton = () => {
  const [showTooltip, setShowTooltip] = useState(false);
  const whatsappNumber = '919154900228'; // India country code + number
  const defaultMessage = encodeURIComponent(
    "Hi CLARIAS Team! I need help with..."
  );
  
  const whatsappUrl = `https://wa.me/${whatsappNumber}?text=${defaultMessage}`;
  
  return (
    <div className="fixed bottom-20 sm:bottom-20 right-6 sm:right-8 z-40">
      {/* Tooltip */}
      {showTooltip && (
        <div className="absolute bottom-16 right-0 bg-white rounded-lg shadow-xl border border-gray-200 p-3 w-48 animate-in fade-in slide-in-from-bottom-2 duration-200">
          <button 
            onClick={() => setShowTooltip(false)}
            className="absolute -top-2 -right-2 bg-gray-100 rounded-full p-1 hover:bg-gray-200"
          >
            <X className="w-3 h-3 text-gray-500" />
          </button>
          <p className="text-sm text-gray-700 font-medium mb-1">Need Help?</p>
          <p className="text-xs text-gray-500 mb-2">Chat with us on WhatsApp for quick support!</p>
          <a
            href={whatsappUrl}
            target="_blank"
            rel="noopener noreferrer"
            className="block w-full text-center bg-green-500 hover:bg-green-600 text-white text-xs font-medium py-2 px-3 rounded-lg transition-colors"
            data-testid="whatsapp-chat-btn"
          >
            Start Chat
          </a>
        </div>
      )}
      
      {/* Main Button */}
      <button
        onClick={() => setShowTooltip(!showTooltip)}
        onMouseEnter={() => setShowTooltip(true)}
        className="bg-green-500 hover:bg-green-600 text-white rounded-full p-4 shadow-lg hover:shadow-xl transition-all duration-200 hover:scale-110 focus:outline-none focus:ring-2 focus:ring-green-400 focus:ring-offset-2"
        aria-label="WhatsApp Support"
        data-testid="whatsapp-support-btn"
      >
        <MessageCircle className="w-6 h-6" />
      </button>
      
      {/* Pulse animation */}
      <span className="absolute top-0 right-0 -mt-1 -mr-1">
        <span className="animate-ping absolute inline-flex h-3 w-3 rounded-full bg-green-400 opacity-75"></span>
        <span className="relative inline-flex rounded-full h-3 w-3 bg-green-500"></span>
      </span>
    </div>
  );
};

export default WhatsAppButton;
